const staticUrl = {
    pediaStudy: "https://pedia-study.org/",
    ncbi: "https://www.ncbi.nlm.nih.gov/pubmed/",
    arxivPdf: "https://arxiv.org/pdf/1801.07637v1.pdf",
    fdna: "http://www.fdna.com",
    fdnaTermsOfUse: "https://www.face2gene.com/terms-and-conditions/",
    fdnaPrivacyPolicy: "https://www.face2gene.com/privacy-policy/",
    face2geneTermsAndConditions: "http://www.face2gene.com/terms-and-conditions/",
    face2gene: "http://www.face2gene.com",
    face2geneAnalysis: "https://www.face2gene.com/analysis/",
    face2geneDScore: "https://www.face2gene.com/facial-dscore-what-is/",
    disgenet: "http://www.disgenet.org/",
    omimEntry: "http://www.omim.org/entry/",
    omimPhenotypic: "https://www.omim.org/phenotypicSeries/",
    orphanet: "https://www.orpha.net/en/disease/detail/",
    ncbiBooksTerm: "https://www.ncbi.nlm.nih.gov/books/?term=",
    ncbiConditionsTerm: "http://www.ncbi.nlm.nih.gov/gtr/conditions/?term=",
    inviteNewLabGoogleForm: "https://goo.gl/forms/G6wWUGJuYVsibQLP2",
    handbookPhysicalMeasurement: "https://www.amazon.com/Handbook-Physical-Measurements-Judith-Hall/dp/0195301498",
    ggcHealthcareProfessional: "https://ggc.org/healthcare-professionals",
    ggcEConsult: "http://ggc.org/wp-content/uploads/2022/12/F2G-eConsult-info-sheet.pdf",
    doxBaseUrl: "https://auth.doximity.com/oauth/authorize?",
    goggleAuthBaseUrl: "https://accounts.google.com/o/oauth2/v2/auth?",
    googleAppLink: "https://g8hps.app.goo.gl/?link=",
    sentryProjects: "https://sentry.io/api/0/projects/",
    fdnaTnCUS: "https://www.face2gene.com/termsconditions-us/",
    fdnaPrivacyPolicyUS: "https://www.face2gene.com/privacy-policy-usa/"
}


module.exports = {
    staticUrl
}


// WEBPACK FOOTER //
// ./common/staticUrl.js